<app-slider></app-slider>
<app-intro></app-intro>
<!-- <app-about></app-about> -->
<!-- <app-ereader></app-ereader> -->